import Lenis from "lenis";

let lenisInstance = null;

export const initLenis = () => {
  const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  lenisInstance = lenis;
  let raf;
  const loop = (time) => {
    lenis.raf(time);
    raf = requestAnimationFrame(loop);
  };
  raf = requestAnimationFrame(loop);
  return () => {
    cancelAnimationFrame(raf);
    lenis.destroy();
    lenisInstance = null;
  };
};

export const scrollToId = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (lenisInstance) lenisInstance.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
